import React, { useEffect } from 'react';
import styles from '../../styles/CierreCicloEscolarStyles/CierreCicloEscolar.module.css';

function PendingGradesModal({ program, pendingGrades, onClose, onContinuar }) {
  useEffect(() => {
    const handleEscape = (e) => {
      if (e.key === 'Escape') {
        onClose();
      }
    };

    document.addEventListener('keydown', handleEscape);
    document.body.style.overflow = 'hidden';

    return () => {
      document.removeEventListener('keydown', handleEscape);
      document.body.style.overflow = 'unset';
    };
  }, [onClose]);

  const handleOverlayClick = (e) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  const handleDownload = () => {
    console.log('Descargar lista de calificaciones pendientes');
    // Implementar lógica de descarga
  };

  return (
    <div 
      className={styles.modalOverlay} 
      onClick={handleOverlayClick}
      role="dialog"
      aria-modal="true"
      aria-labelledby="pending-grades-modal-title"
    >
      <div className={styles.pendingGradesModal}>
        <div className={styles.modalHeader}>
          <h2 id="pending-grades-modal-title" className={styles.modalTitle}>
            Calificaciones Pendientes
          </h2>
          <button 
            className={styles.closeButton} 
            onClick={onClose}
            aria-label="Cerrar modal"
          >
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <line x1="18" y1="6" x2="6" y2="18"/>
              <line x1="6" y1="6" x2="18" y2="18"/>
            </svg>
          </button>
        </div>
        
        <div className={styles.modalContent}>
          {/* Warning Alert */}
          <div className={styles.warningAlert}>
            <div className={styles.warningIcon}>
              <svg viewBox="0 0 24 24" fill="currentColor">
                <path d="M1 21h22L12 2 1 21zm12-3h-2v-2h2v2zm0-4h-2v-4h2v4z"/>
              </svg>
            </div>
            <div className={styles.warningContent}>
              <div className={styles.warningTitle}>Existen materias pendientes de calificar</div>
              <div className={styles.warningText}>
                Debe completar las calificaciones pendientes antes de proceder con el cierre del ciclo.
              </div>
            </div>
          </div>

          {/* Pending Grades Table */}
          <div className={styles.pendingGradesSection}>
            <div className={styles.pendingGradesSectionHeader}>
              <div className={styles.tableSectionIcon}>
                <svg viewBox="0 0 24 24" fill="currentColor">
                  <path d="M19 3h-4.18C14.4 1.84 13.3 1 12 1c-1.3 0-2.4.84-2.82 2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-7 0c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zm2 14H7v-2h7v2zm3-4H7v-2h10v2zm0-4H7V7h10v2z"/>
                </svg>
              </div>
              <h3 className={styles.pendingGradesSectionTitle}>Calificaciones Pendientes</h3>
            </div>
            
            <div className={styles.pendingGradesTable}>
              <div className={styles.pendingGradesTableHeader}>
                <div className={styles.headerCell}>Materia</div>
                <div className={styles.headerCell}>Grupo</div>
                <div className={styles.headerCell}>Asesor</div>
                <div className={styles.headerCell}>Matrícula</div>
                <div className={styles.headerCell}>Estudiante</div>
                <div className={styles.headerCell}>Estado</div>
              </div>
              
              <div className={styles.tableBody}>
                {pendingGrades.map((grade, index) => (
                  <div key={index} className={styles.pendingGradesTableRow}>
                    <div className={styles.tableCell}>{grade.materia}</div>
                    <div className={styles.tableCell}>{grade.grupo}</div>
                    <div className={styles.tableCell}>{grade.asesor}</div>
                    <div className={styles.tableCell}>{grade.matricula}</div>
                    <div className={styles.tableCell}>{grade.estudiante}</div>
                    <div className={styles.tableCell}>
                      <span className={styles.pendingBadge}>{grade.estado}</span>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
        
        <div className={styles.modalFooter}>
          <button className={styles.downloadButton} onClick={handleDownload}>
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/>
              <polyline points="7 10 12 15 17 10"/>
              <line x1="12" y1="15" x2="12" y2="3"/>
            </svg>
            Descargar
          </button>
          {onContinuar && (
            <button className={styles.confirmButton} onClick={onContinuar}>
              CONTINUAR DE TODAS FORMAS
            </button>
          )}
          <button className={styles.closeModalButton} onClick={onClose}>
            CERRAR
          </button>
        </div>
      </div>
    </div>
  );
}

export default PendingGradesModal;
